import * as React from "react";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { ChargesOnIllustration } from "../../Common/AdviserCharges/Components/ChargesOnIlustration";
import { IAC } from "../../Common/AdviserCharges/Components/IAC";
import { OAC } from "../../Common/AdviserCharges/Components/OAC";
import { RIAC } from "../../Common/AdviserCharges/Components/RIAC";
import { SubAccountTypeHelper } from "../../Common/Helpers/SubAccountTypeHelper";

interface IEditAdviserChargesProps extends IProcessComponentProps {
    type: SubAccountType;
}

interface IEditAdviserChargesState {}

export class EditAdviserCharges extends ProcessComponent<IEditAdviserChargesProps, IEditAdviserChargesState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
        };
    };

    public render(): JSX.Element {
        const { type } = this.props;
        return (
            <>
                <h2 className="mb-22">Edit Adviser charges</h2>

                <IAC type={type} {...this.getProps("Contribution")} />

                {SubAccountTypeHelper.isOnPlatformPension(type) && <RIAC type={SubAccountType.Npr} {...this.getProps("Contribution")} />}

                <OAC type={type} {...this.getProps("Contribution")} />

                <ChargesOnIllustration {...this.getProps("Contribution")} />
            </>
        );
    }
}
